import { render, staticRenderFns } from "./sa-organization-user-details.html?vue&type=template&id=227c40ea&scoped=true&external"
import script from "./sa-organization-user-details.js?vue&type=script&lang=js&external"
export * from "./sa-organization-user-details.js?vue&type=script&lang=js&external"
import style0 from "./sa-organization-user-details.scss?vue&type=style&index=0&id=227c40ea&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227c40ea",
  null
  
)

export default component.exports